const separator = "_separator_144s5_17";
const styles = {
  separator
};
export {
  styles as default,
  separator
};
//# sourceMappingURL=Separator.module.css.js.map
